
import { rmc } from '.././firestoreConfig';
import { fetchAndActivate, getValue } from "firebase/remote-config";
class ConfigService {
    async getConfigStatus() {
        try {
            // Haal de nieuwste configuratie op en activeer deze onmiddellijk
            const fetched = await fetchAndActivate(rmc);
            
            if (fetched) {
                console.log("Nieuwe configuratie geactiveerd.");
            } else {
                console.log("Configuratie is al up-to-date.");
            }

            // Haal de waarde van de parameter op
            const configValue = getValue(rmc, 'config').asString();
            const configObject = JSON.parse(configValue);
            return configObject;

        } catch (error) {
            console.error("Fout bij het ophalen van Remote Config:", error);
            return rmc.defaultConfig.config; 
        }
    }
}

export default new ConfigService();